import React, { useRef, useState } from "react";
import TextField from "../components/textField";
import BankNumberField from "../components/bankNumberField";
import { md5 } from "js-md5";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

interface LoginModalProps {
  setShowLoginModal: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setUser: React.Dispatch<any>;
}

const LoginModal = ({
  setShowLoginModal,
  setLoading,
  setUser,
}: LoginModalProps) => {
  const [account, setAccount] = useState("");
  const [bankDigits, setBankDigits] = useState(["", "", "", ""]);
  const digitRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleDigitChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const newDigits = [...bankDigits];
    newDigits[index] = value;
    setBankDigits(newDigits);

    if (value && index < digitRefs.current.length - 1) {
      digitRefs.current[index + 1]?.focus();
    }
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const bankCard = bankDigits.join("");
    const dateTimeNow = Date.now().toString();
    const hash = md5(
      `${account}&${bankCard}&${process.env.REACT_APP_API_KEY}&${dateTimeNow}-${process.env.REACT_APP_API_SECRET_KEY}`
    );

    try {
      const requestParam = {
        Account: account,
        BankCard: bankCard,
        ApiKey: process.env.REACT_APP_API_KEY,
        UtcTime: dateTimeNow,
        Sign: hash,
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/LiveStream/AccountCheck`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestParam),
        }
      );

      const result = await response.json();

      if (result) {
        Cookies.set("user", JSON.stringify(result.data), {
          expires: 1, // 1 day = 24 hours
          sameSite: "strict",
        });
        setUser(result.data); // Set state as well as cookie

        setShowLoginModal(false);

        if (result.code === 400) {
          Swal.fire({
            title: "THẤT BẠI",
            text: result.message,
            icon: "error",
            confirmButtonText: "Xác nhận",
            confirmButtonColor: "red",
          });
        }
      }
      // Do something with result here
    } catch (error) {
      console.error("Error :", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80 relative items-center flex flex-col">
        {/* Close button at top-right */}
        <button
          onClick={() => setShowLoginModal(false)}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          ✕
        </button>
        <img
          src={`${process.env.PUBLIC_URL}/img/logo.png`}
          alt="J88 Logo"
          className="h-10"
        />
        <h2 className="text-lg font-bold mb-4 text-center">Đăng Nhập</h2>
        <form onSubmit={handleLogin}>
          <TextField
            id="account"
            imgAlt="J88 Logo"
            label="Tên tài khoản của bạn"
            type="text"
            placeholder="Vui Lòng Nhập Tên Tài Khoản"
            className=" w-full mb-4 border"
            value={account}
            autoFocus
            onChange={(e) => {
              setAccount(e.target.value);
            }}
            required
          />
          <BankNumberField
            imgAlt="bank Logo"
            label="Xác nhận 4 số cuối tài khoản ngân hàng"
            bankDigits={bankDigits}
            digitRefs={digitRefs}
            handleDigitChange={handleDigitChange}
            required
          />

          <div className="flex justify-center">
            <button
              type="submit"
              className="px-4 py-2 text-sm bg-[#EB0000] text-white rounded w-full"
            >
              XÁC NHẬN
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
